export const TEST_ID = {
  suggestionCard: 'suggestionCard',
  cardButton: 'cardButton',
};
